export const tiposContratacao = [
    { value: 1, text: 'Proposta com aceite' },
    { value: 2, text: 'Contrato' },
    { value: 3, text: 'Mapa Comparativo' },
    { value: 4, text: 'Autorização Direta' },
    { value: 5, text: 'Termo de Cadastramento' }
]
